<template>
    <div class="filter">
        <div class="ui form" @keypress.enter="$parent.core_waybills_filter()" v-if="is_initialized">
            <div class="ui list">
                <!--
                * ========================================================================
                * = 號碼相關
                * ========================================================================
                -->
                <div class="item">
                    <i class="barcode big icon pointer"
                        @click="is_show_numbers = !is_show_numbers">
                    </i>
                    <div class="content">
                        <div class="header pointer">
                            <h3 @click="is_show_numbers = !is_show_numbers"  style="z-index: 2;">
                                {{ $t('ui.pages.core_waybills.filter.numbers') }}
                                <i class="icon"
                                    style="margin: 0;"
                                    :class="{
                                        'caret down': !is_show_numbers,
                                        'caret up': is_show_numbers,
                                    }"
                                ></i>
                            </h3>
                        </div>
                        <transition name="slide-fade" mode="out-in">
                            <div v-show="is_show_numbers">
                            <div class="filter_border"></div>
                            <div class="two fields">
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.number') }}</label>
                                    <input type="text"
                                        v-model="filter.number"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.operation_number') }}</label>
                                    <input type="text"
                                        v-if="!$route.params.operation_number"
                                        v-model="filter.operation.number"
                                    >
                                    <div class="ui segment"
                                        style="margin: 0; padding: 9px 12px;"
                                        v-else>
                                        {{ $route.params.operation_number }}
                                    </div>
                                </div>
                            </div>
                            <div class="three fields">
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.original_number') }}</label>
                                    <input type="text"
                                        v-model="filter.original_number"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.tracking_number') }}</label>
                                    <input type="text"
                                        v-model="filter.tracking_number"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.flight_number') }}</label>
                                    <input type="text"
                                        v-model="filter.flight_number"
                                    >
                                </div>
                            </div>
                            <div class="two fields">
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.storage_number') }}</label>
                                    <input type="text"
                                        v-model="filter.storage_number"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.warehouse_identity') }}</label>
                                    <input type="text"
                                        v-model="filter.warehouse_identity"
                                    >
                                </div>
                            </div>

                        </div>
                        </transition>
                    </div>
                </div>
                <!--
                * ========================================================================
                * = 運單內容
                * ========================================================================
                -->
                <div class="item">
                    <i class="file alternate big icon pointer"
                        @click="is_show_info = !is_show_info">
                    </i>
                    <div class="content">
                        <div class="header pointer">
                            <h3 @click="is_show_info = !is_show_info">
                                {{ $t('ui.pages.core_waybills.filter.waybill_content') }}
                                <i class="icon"
                                    style="margin: 0;"
                                    :class="{
                                        'caret down': !is_show_info,
                                        'caret up': is_show_info,
                                    }"
                                ></i>
                            </h3>
                        </div>
                        <transition name="slide-fade" mode="out-in">
                            <div v-show="is_show_info">
                            <div class="filter_border"></div>
                            <div class="two fields">
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.sender_name') }}</label>
                                    <input type="text"
                                        v-model="filter.sender_name"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.sender_company_name') }}</label>
                                    <input type="text"
                                        v-model="filter.sender_company_name"
                                    >
                                </div>
                                <div class="field">
                                    <div class="two fields">
                                        <div class="field">
                                            <label> {{ $t('models.attributes.core_waybills.is_used') }}</label>

                                            <div class="grouped fields">
                                                <div class="field"
                                                    v-for="filter_is_used in filter_is_useds"
                                                    @click="set_is_used(filter_is_used.boolean)"
                                                    >
                                                    <div class="ui radio checkbox" ref="filter_is_used">
                                                        <input type="radio"
                                                            name="filter_is_used"
                                                            v-model="filter.is_used"
                                                            :id="filter_is_used.name"
                                                            >
                                                        <label :for="filter_is_used.name">
                                                            {{ filter_is_used.name }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="field">
                                            <label>{{ $t('ui.pages.core_waybills.filter.material') }}</label>
                                            <div v-dropdown class="ui selection fluid dropdown">
                                                <div class="text"
                                                    v-for="material in materials"
                                                    v-if="filter.material.class_names == material.class_name">
                                                    {{ material.name }}
                                                </div>
                                                <i class="dropdown icon"></i>
                                                <div class="menu">
                                                    <div
                                                        v-for="material in materials"
                                                        @click="filter.material.class_names = material.class_name"
                                                        class="item"
                                                        :class="{
                                                            'selected active': filter.material.class_names == material.class_name
                                                        }">
                                                        {{ material.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="three fields">
                                <div class="field blue">
                                    <label>{{ $t('models.attributes.core_waybills.consignee_name') }}</label>
                                    <input type="text"
                                        v-model="filter.consignee_name"
                                    >
                                </div>
                                <div class="field blue">
                                    <label>{{ $t('models.attributes.core_waybills.consignee_company_name') }}</label>
                                    <input type="text"
                                        v-model="filter.consignee_company_name"
                                    >
                                </div>
                                <div class="field blue">
                                    <label>{{ $t('models.attributes.core_waybills.consignee_phone') }}</label>
                                    <input type="text"
                                        v-model="filter.consignee_phone"
                                    >
                                </div>
                                <div class="field blue">
                                    <label>{{ $t('models.attributes.core_waybills.consignee_address') }}</label>
                                    <input type="text"
                                        v-model="filter.consignee_address"
                                    >
                                </div>
                            </div>

                            <div class="two fields">
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.note') }}</label>
                                    <input type="text"
                                        v-model="filter.note"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.shipping_note') }}</label>
                                    <input type="text"
                                        v-model="filter.shipping_note"
                                    >
                                </div>
                            </div>

                            <div class="two fields">
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.created_at') }}</label>
                                    <DatePicker
                                        v-model="filter.created_duration"
                                        :re_init="Boolean(filter.created_duration)"
                                        style="width: 100%;"
                                        type="daterange"
                                        format="YYYY-MM-DD"
                                        key="core_waybills_created_duration">
                                    </DatePicker>
                                </div>

                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.shipping_date') }}</label>
                                    <DatePicker
                                        v-model="filter.shipping_date_duration"
                                        :re_init="Boolean(filter.shipping_date_duration)"
                                        style="width: 100%;"
                                        type="daterange"
                                        format="YYYY-MM-DD"
                                        key="core_waybills_created_duration">
                                    </DatePicker>
                                </div>

                            </div>
                        </div>
                        </transition>
                    </div>
                </div>
                <!--
                * ========================================================================
                * = 貨況 (condition + status)
                * ========================================================================
                -->
                <div class="item">
                    <i class="shipping fast big icon pointer"
                        @click="is_show_status = !is_show_status">
                    </i>
                    <div class="content">
                        <div class="header pointer">
                            <h3 @click="is_show_status = !is_show_status">
                                {{ $t('ui.pages.core_waybills.filter.status') }}
                                <i class="icon"
                                    style="margin: 0;"
                                    :class="{
                                        'caret down': !is_show_status,
                                        'caret up': is_show_status,
                                    }"
                                ></i>
                            </h3>
                        </div>
                        <transition name="slide-fade" mode="out-in">
                            <div v-show="is_show_status" class="status_filter">
                                <div class="filter_border"></div>
                                <!--
                                * ========================================================================
                                * = condition
                                * = 目前運單為 "Polarity" "Condition", 在"何處", 最後由 "誰" 處理
                                * ========================================================================
                                -->
                                <div class="field" style="margin: 0 0 -.7em;">
                                    <div class="fields">
                                        <div class="eight wide field">
                                            <h4 class="depiction">
                                                <!-- 現在 運單 -->
                                                {{ $t('ui.pages.core_waybills.filter.status_depiction.now') }}
                                                &nbsp;
                                            </h4>
                                            <div v-dropdown class="ui fluid selection dropdown" style="width:30%;">
                                                <div class="text"
                                                    v-for="polarity_selection in [
                                                        {name: $t('ui.pages.core_waybills.filter.selected_polarity'), boolean: null},
                                                        {name: $t('ui.pages.core_waybills.filter.polarity.positive'), boolean: 'true'},
                                                        {name: $t('ui.pages.core_waybills.filter.polarity.negative'), boolean: 'false'}
                                                    ]"
                                                    v-if="filter.condition.polarity == polarity_selection.boolean">
                                                    {{ polarity_selection.name }}
                                                </div>
                                                <i class="dropdown icon"></i>
                                                <div class="menu">
                                                    <div class="item"
                                                        @click="filter.condition.polarity = null"
                                                        :class="{'selected active': filter.condition.polarity == null }"
                                                    >
                                                        {{ $t('ui.pages.core_waybills.filter.selected_is_used') }}
                                                    </div>
                                                    <div
                                                        v-for="polarity_selection in [
                                                            {name: $t('ui.pages.core_waybills.filter.polarity.positive'), boolean: 'true'},
                                                            {name: $t('ui.pages.core_waybills.filter.polarity.negative'), boolean: 'false'}
                                                        ]"
                                                        @click="filter.condition.polarity = polarity_selection.boolean"
                                                        class="item"
                                                        :class="{
                                                            'selected active': filter.condition.polarity == polarity_selection.boolean
                                                        }">
                                                        {{ polarity_selection.name }}
                                                    </div>
                                                </div>
                                            </div>
                                            <span class="depiction">&nbsp;</span>
                                            <div v-dropdown class="ui fluid selection dropdown" style="width:35%;">
                                                <div class="text"
                                                    v-for="value in current_store.core_waybill_conditions"
                                                    v-if="filter.condition.name == value">
                                                    {{ $t('models.attributes.conditions["' + value+ '"]') }}
                                                </div>
                                                <div class="text"
                                                    v-if="filter.condition.name == null">
                                                    {{ $t('ui.pages.core_waybills.filter.selected_status') }}
                                                </div>

                                                <i class="dropdown icon"></i>
                                                <div class="menu">
                                                    <div class="item"
                                                        @click="filter.condition.name = null"
                                                        :class="{'selected active': filter.condition.name == null }"
                                                    >
                                                        {{ $t('ui.pages.core_waybills.filter.selected_status') }}
                                                    </div>

                                                    <div
                                                        v-for="value in current_store.core_waybill_conditions"
                                                        v-if="value != 'divider'"
                                                        @click="filter.condition.name = value"
                                                        class="item"
                                                        :class="{
                                                            'selected active': filter.condition.name == value
                                                        }">
                                                        {{ $t('models.attributes.conditions["' + value+ '"]') }}
                                                    </div>
                                                    <div v-else class="divider" style="margin: 0.2em 0;">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="four wide field">
                                            <h4 class="depiction">
                                                <!-- 在 -->
                                                {{ $t('ui.pages.core_waybills.filter.status_depiction.in_the') }}
                                                &nbsp;
                                            </h4>
                                            <div v-dropdown class="ui fluid selection dropdown" style="width:80%;">
                                                <div class="text"
                                                    v-for="station in stations"
                                                    v-if="filter.condition.current_location == station.name">
                                                    {{ station.name || $t('ui.pages.core_waybills.filter.selected_station') }}
                                                </div>
                                                <i class="dropdown icon"></i>
                                                <div class="menu">
                                                    <div
                                                        v-for="station in stations"
                                                        @click="filter.condition.current_location = station.name"
                                                        :key="station.identity"
                                                        class="item"
                                                        :class="{
                                                            'selected active': filter.condition.current_location == station.name
                                                        }">
                                                        {{ station.name || $t('ui.pages.core_waybills.filter.selected_station') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="four wide field">
                                            <h4 class="depiction">
                                                <!-- 由 -->
                                                {{ $t('ui.pages.core_waybills.filter.status_depiction.by') }}
                                                &nbsp;
                                            </h4>
                                            <div v-dropdown class="ui fluid selection dropdown" style="width:70%;">
                                                <div class="text"
                                                    v-for="staff in staffs"
                                                    v-if="filter.condition.current_operator_identity == staff.identity">
                                                    {{ staff.name }}
                                                </div>
                                                <i class="dropdown icon"></i>
                                                <div class="menu">
                                                    <div
                                                        v-for="staff in staffs"
                                                        @click="filter.condition.current_operator_identity = staff.identity"
                                                        :key="staff.identity"
                                                        class="item"
                                                        :class="{
                                                            'selected active': filter.condition.current_operator_identity == staff.identity
                                                        }">
                                                        {{ staff.name }}
                                                    </div>
                                                </div>
                                            </div>
                                            <h4 class="depiction">
                                                &nbsp;
                                                <!-- 處理 -->
                                                {{ $t('ui.pages.core_waybills.filter.status_depiction.handle') }}
                                            </h4>
                                        </div>
                                    </div>
                                </div>

                                <div class="field" :style="(style.width > 767) ? {textAlign: 'right'} : {marginTop:'12px'} ">
                                    <div style="display:inline-flex; align-items: center;">
                                        <h4 style="margin-right: 9px;">
                                            <!-- 在 -->
                                            {{ $t('ui.pages.core_waybills.filter.status_depiction.at_the') }}
                                        </h4>
                                        <DatePicker
                                            class="core_waybills_condition_updated_duration"
                                            v-model="filter.condition.updated_duration"
                                            :style="(style.width > 767) ? {width: '90%'} : {width:'100%'}"
                                            :is_row="(style.width > 767) ? false : true"
                                            :re_init="Boolean(filter.condition.updated_duration)"
                                            type="datetimerange"
                                            key="core_waybills_condition_updated_duration">
                                        </DatePicker>
                                        <!-- <el-date-picker
                                            style="width: 90%;"
                                            v-model="filter.condition.updated_duration"
                                            unlink-panels
                                            type="daterange"
                                            align="center"
                                            :start-placeholder="$t('ui.el.datepicker.startDate')"
                                            :end-placeholder="$t('ui.el.datepicker.endDate')"
                                            :picker-options="$store.state.element_ui_datepicker_daterange_options"
                                            >
                                        </el-date-picker> -->
                                    </div>
                                    <div class="sub_filter_border">
                                    </div>
                                </div>
                                <!--
                                * ========================================================================
                                * = status
                                * = 曾經由"誰"在"何時", 新增了"何種Scope"的貨況
                                * ========================================================================
                                -->
                                <div class="field">
                                    <div class="fields">
                                        <div class="six wide field">
                                            <h4 class="depiction">
                                                <!-- 曾經由 -->
                                                {{ $t('ui.pages.core_waybills.filter.status_depiction.before_by') }}
                                                &nbsp;
                                            </h4>
                                            <div v-dropdown class="ui fluid selection dropdown" style="width:70%;">
                                                <div class="text"
                                                    v-for="staff in staffs"
                                                    v-if="filter.status.operator_identity == staff.identity">
                                                    {{ staff.name }}
                                                </div>
                                                <i class="dropdown icon"></i>
                                                <div class="menu">
                                                    <div
                                                        v-for="staff in staffs"
                                                        @click="filter.status.operator_identity = staff.identity"
                                                        :key="staff.identity"
                                                        class="item"
                                                        :class="{
                                                            'selected active': filter.status.operator_identity == staff.identity
                                                        }">
                                                        {{ staff.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="six wide field">
                                            <h4 class="depiction">
                                                <!-- 在 -->
                                                {{ $t('ui.pages.core_waybills.filter.status_depiction.in_the') }}
                                                &nbsp;
                                            </h4>
                                            <div class="ui fluid selection dropdown"
                                                v-dropdown
                                                style="width:80%;"
                                                :class="{
                                                    'disabled': current_staff.theme_name != 'manager'
                                                }">
                                                <div class="text"
                                                    v-for="station in stations"
                                                    v-if="filter.status.location == station.name">
                                                    {{ station.name || $t('ui.pages.core_waybills.filter.selected_station') }}
                                                </div>
                                                <i class="dropdown icon"></i>
                                                <div class="menu">
                                                    <div
                                                        v-for="station in stations"
                                                        @click="filter.status.location = station.name"
                                                        :key="station.identity"
                                                        class="item"
                                                        :class="{
                                                            'selected active': filter.status.location == station.name
                                                        }">
                                                        {{ station.name || $t('ui.pages.core_waybills.filter.selected_station') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="four wide field">
                                            <h4 class="depiction">
                                                <!-- 新增了 -->
                                                {{ $t('ui.pages.core_waybills.filter.status_depiction.added') }}
                                                &nbsp;
                                            </h4>
                                            <div v-dropdown class="ui fluid selection dropdown" style="width:35%;">
                                                <div
                                                    class="text"
                                                    v-for="status_scope_selection in ['operator','forwarder','public']"
                                                    v-if="filter.status.scope == status_scope_selection">
                                                    {{ $t("ui.status_scopes."+status_scope_selection) }}
                                                </div>
                                                <div v-if="filter.status.scope == null">
                                                    {{ $t('ui.pages.core_waybills.filter.selected_status_scope') }}
                                                </div>
                                                <i class="dropdown icon"></i>
                                                <div class="menu">
                                                    <div class="item"
                                                        @click="filter.status.scope = null"
                                                        :class="{'selected active': filter.status.scope == null }"
                                                    >
                                                        {{ $t('ui.pages.core_waybills.filter.selected_status_scope') }}
                                                    </div>
                                                    <div
                                                        v-for="status_scope_selection in ['operator','forwarder','public']"
                                                        @click="filter.status.scope = status_scope_selection"
                                                        class="item"
                                                        :class="{
                                                            'selected active': filter.status.scope == status_scope_selection
                                                        }">
                                                        {{ $t("ui.status_scopes."+status_scope_selection) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <span class="depiction">&nbsp;</span>
                                            <div v-dropdown class="ui fluid selection dropdown" style="width:42%;">
                                                <div
                                                    class="text"
                                                    v-for="(scan_action_prototype, index) in scan_action_prototypes"
                                                    v-if="filter.status.name == scan_action_prototype.name">
                                                    {{ scan_action_prototype.name }}
                                                </div>
                                                <div v-if="filter.status.name == null">
                                                    {{ $t('ui.pages.core_waybills.filter.selected_status') }}
                                                </div>
                                                <i class="dropdown icon"></i>
                                                <div class="menu">
                                                    <div class="item"
                                                        @click="filter.status.name = null"
                                                        :class="{'selected active': filter.status.name == null }"
                                                    >
                                                        {{ $t('ui.pages.core_waybills.filter.selected_status') }}
                                                    </div>
                                                    <div
                                                        v-for="(scan_action_prototype, index) in scan_action_prototypes"
                                                        @click="filter.status.name = scan_action_prototype.name"
                                                        class="item"
                                                        :class="{
                                                            'selected active': filter.status.name == scan_action_prototype.name
                                                        }">
                                                        {{ scan_action_prototype.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field" :style="(style.width > 767) ? {textAlign: 'right'} : {marginTop:'12px'} ">
                                    <div style="display:inline-flex; align-items: center;">
                                        <h4 style="margin-right: 9px;">
                                            <!-- 在 -->
                                            {{ $t('ui.pages.core_waybills.filter.status_depiction.at_the') }}
                                        </h4>
                                        <DatePicker
                                            v-model="filter.status.created_duration"
                                            :style="(style.width > 767) ? {width: '90%'} : {width:'100%'}"
                                            :re_init="Boolean(filter.status.created_duration)"
                                            type="daterange"
                                            format="YYYY-MM-DD"
                                            key="core_waybills_status_created_duration">
                                        </DatePicker>
                                        <!-- <el-date-picker
                                            style="width: 90%;"
                                            v-model="filter.status.created_duration"
                                            unlink-panels
                                            type="daterange"
                                            align="center"
                                            :start-placeholder="$t('ui.el.datepicker.startDate')"
                                            :end-placeholder="$t('ui.el.datepicker.endDate')"
                                            :picker-options="$store.state.element_ui_datepicker_daterange_options"
                                            >
                                        </el-date-picker> -->
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
        <div class="ui active centered inline loader" v-else></div>
    </div>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    props: {
    },
    data() {
        return {
            is_show_numbers: true,
            is_show_info: true,
            is_show_status: true,
            is_initialized: false,
            is_processing: false,
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.provider.core_waybills_module
        },
        filter() {
            return this.current_store.filter
        },
        staffs() {
            return [{
                name: this.$t('ui.pages.core_waybills.filter.selected_staff'),
                identity: null,
            }].concat(this.current_store.staffs)
        },
        stations() {
            return [{
                name: null,
                identity: null,
            }].concat(this.$store.state.provider.stations)
        },
        materials() {
            return [{
                name: this.$t('ui.pages.core_waybills.filter.selected_material'),
                class_name: null,
            }].concat(this.current_store.materials)
        },
        filter_is_useds() {
            return [
                {name: this.$t('ui.pages.core_waybills.filter.is_used.flase'), boolean: 'false'},
                {name: this.$t('ui.pages.core_waybills.filter.is_used.true'), boolean: 'true'},
            ]
        },
        scan_action_prototypes() {
            return this.current_store.scan_action_prototypes
        },
        current_staff() {
            return this.$store.state.provider.current_staff
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                let query = this.$store.getters['provider/core_waybills_module/filter_to_query']
                if (Object.keys(query).length) {
                    if (
                        !this.filter.number &&
                        !this.filter.operation.number &&
                        !this.filter.original_number &&
                        !this.filter.tracking_number &&
                        !this.filter.flight_number
                    ) {
                        this.is_show_numbers = false
                    }
                    if (
                        !this.filter.sender_name &&
                        !this.filter.sender_company_name &&
                        !this.filter.is_used &&
                        !this.filter.consignee_name &&
                        !this.filter.consignee_company_name &&
                        !this.filter.consignee_phone &&
                        !this.filter.consignee_address &&
                        !this.filter.created_duration &&
                        !this.filter.shipping_date_duration &&
                        !this.filter.note &&
                        !this.filter.shipping_note
                    ) {
                        this.is_show_info = false
                    }
                    if (
                        !this.filter.sender_name &&
                        !this.filter.is_used &&
                        !this.filter.condition.name &&
                        !this.filter.condition.current_location &&
                        !this.filter.condition.current_operator_identity &&
                        !this.filter.condition.updated_duration &&
                        !this.filter.status.location &&
                        !this.filter.status.operator_identity &&
                        !this.filter.status.created_duration &&
                        !this.filter.status.scope &&
                        !this.filter.status.name
                    ) {
                        this.is_show_status = false
                    }
                }

                if (this.current_staff.current_station.identity) {
                    this.filter.status.location = this.current_staff.current_station.name;
                }
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        set_is_used(boolean = null) {
            this.filter.is_used = (this.filter.is_used == boolean) ? null : boolean
            if (this.filter.is_used == null) {
                $(this.$refs.filter_is_used).checkbox('uncheck')
            }
        },
    },
    components: {
        DatePicker
    },
}
</script>
<style>
.el-date-editor.el-range-editor input {
    border: none !important;
}
.core_waybills_condition_updated_duration .el-date-editor--datetimerange{
    width: 100% !important;
}
.core_waybills_condition_updated_duration .el-range-input {
    width: 39% !important;
}
</style>
<style scoped lang="scss">
    .filter_border {
        border: 0.5px #666 solid;
        margin: 12px 0;
    }
    .sub_filter_border {
        border: 0.5px #999 dashed;
        margin: 12px 0;
    }
    .status_filter {
        .depiction {
            display: inline-block;
            margin: 0px;
        }
        .depiction + div {
            display: inline-block;
            margin-bottom: 6px;
        }
    }
    .ui.list .item {
        & {
            padding-bottom: 9px;
        }
        .content {
            & {
                width: 100%;
            }
            .header {
                margin-bottom: 6px;
            }
        }
    }

    .ui.form .field {
        &.red input {
            border-top: 2px solid #db2828!important;
        }
        &.orange input {
            border-top: 2px solid #f2711c!important;
        }
        &.olive input {
            border-top: 2px solid #b5cc18!important;
        }
        &.green input {
            border-top: 2px solid #21ba45!important;
        }
        &.teal input {
            border-top: 2px solid #00b5ad!important;
        }
        &.blue input {
            border-top: 2px solid #2185d0!important;
        }
        &.violet input {
            border-top: 2px solid #6435c9!important;
        }
        &.purple input {
            border-top: 2px solid #a333c8!important;
        }
        &.grey input {
            border-top: 2px solid #767676!important;
        }
    }
</style>
